import { Button } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import { NoteModals } from '../../../lib/NoteModals';
import { OtpField, ResendOtp, useTimer } from '../../../lib/OtpField';
import { sendPhoneOTP, sendEmailOTP, verifyChangeEmailOTP } from '../../../redux-store/actions/nct';
import { RootStateType } from '../../../redux-store/reducers';
import { addDialCode, OTP_ACTIONS } from '../../../utils/constants';
import { maskMobileNumber } from '../../../utils/utilityFunctions';
const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function UpdatePanOtp(props: any) {
    const { userInfo = null, isEmail = false } = props.location.state || {};
    const [showModal, setShowModal] = useState<boolean>(false);

    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        if (!userInfo) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        try {
            const { pan = '', pekrn = '', mobile = '', email = '' } = props;
            // let payload = isEmail ? { email: userInfo, pan, pekrn, mobile, action:OTP_ACTIONS.updatePan  } : { mobile: `+91${userInfo}`, pan, pekrn, action:OTP_ACTIONS.updatePan };

            let payload: any = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                pan,
                pekrn,
                email,
                mobile,
                action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN,
            };
            if (isEmail) {
                payload = { ...payload, email: userInfo };
            } else {
                payload = { ...payload, mobile: addDialCode(userInfo) };
            }

            await props.verifyChangeEmailOTP(payload);
            props.history.replace('update-pan-list', { userInfo, reqId, otpRef, isEmail });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const onResend = async () => {
        try {
            const { pan = '', pekrn = '', mobile = '' } = props;
            let payload: any = { pan, pekrn, mobile, action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN };
            payload = isEmail
                ? { ...payload, email: userInfo }
                : { ...payload, mobile: addDialCode(userInfo) };
            let res = isEmail
                ? await props.sendEmailOTP(payload)
                : await props.sendPhoneOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <div className="heading">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back"
                    onClick={() => props.history.goBack()}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.goBack();
                        }
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                </a>
                {dashboard.UpdatePan.UpdatePanHeading}
            </div>
            <div className="curved-bg-content">
                <img
                    className="change-email-img"
                    src="/images/change-email-img.png"
                    alt=""
                    aria-hidden="true"
                />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h2 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h2>
                        <p>
                            {dashboard.OtpScreen.otpPhoneSubject}{' '}
                            {isEmail ? dashboard.OtpScreen.registeredEmail : ''}{' '}
                            <span style={{ fontFamily: 'Montserrat-Bold' }}>
                                {isEmail ? `${userInfo}` : maskMobileNumber(userInfo)}
                            </span>
                            {/* <span>
                                {userInfo}, OTP : {otp}
                            </span> */}
                        </p>
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            maskedInfo={`Please enter the 6-digit OTP sent to ${
                                isEmail ? userInfo : maskMobileNumber(userInfo)
                            }`}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            label={dashboard.OtpScreen.buttonText}
                            onClick={handleSubmit}
                            className="customBtn"
                            disabled={otpInput.join('').length !== 6}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendEmailOTP,
    sendPhoneOTP,
    verifyChangeEmailOTP,
})(UpdatePanOtp);
